(function () {
  'use strict';

  angular.module('unit.payment').directive('unitPayment', unitPayment);

  unitPayment.$inject = [];

  function unitPayment() {
    var directive = {
      bindToController: true,
      controller: 'unitPaymentCtrl',
      controllerAs: 'vm',
      template: require('../unit.payment/unit.payment.html'),
      link: link,
      restrict: 'AE',
      scope: {
        unit: '=unit',
        onCancel: '&onCancel',
        onSave: '&onSave',
      },
    };
    return directive;

    function link(scope, element, attrs) {}
  }
})();
